import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import cx from 'classnames';
import * as styles from './styles.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface

export var HiddenInput = /*#__PURE__*/React.forwardRef(function HiddenInput(props, ref) {
  return /*#__PURE__*/React.createElement("input", _extends({}, props, {
    ref: ref,
    className: cx(styles['input'], props.className),
    "aria-hidden": true
  }));
});